import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { dutyStatusChangeRefs } from "../subjects/dutyStatusChange/refs";

/**
 * The driver cleared a special-driving indication.
 */
export const specialDrivingEndedV1 = tmsEventKind(
  { category: "specialDriving", kind: "specialDrivingEnded", version: 1 },
  { refs: dutyStatusChangeRefs, facts: {} },
);

export const SpecialDrivingEndedV1Schema = specialDrivingEndedV1.schema;
export const SpecialDrivingEndedV1FactsSchema = specialDrivingEndedV1.facts;

export type SpecialDrivingEndedV1 = z.infer<typeof SpecialDrivingEndedV1Schema>;
export type SpecialDrivingEndedV1Facts = z.infer<typeof SpecialDrivingEndedV1FactsSchema>;

/** Every version of `specialDrivingEnded`, keyed by version. What `catalog.ts` places under `specialDriving`. */
export const specialDrivingEnded = { 1: specialDrivingEndedV1 } as const;
